import { render, staticRenderFns } from "./VCarManagerTable.vue?vue&type=template&id=48f70008"
import script from "./VCarManagerTable.vue?vue&type=script&lang=js"
export * from "./VCarManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports